module.exports = function (g, j, k, m, q, v, w, x, y, z, A, B, C) {
  var D;
  var E = this;
  this.tmp = {
    scrollDirM: 1,
    showWeapon: true,
    aimFreezeFix: false,
    anonMode: false,
    chatDisplay: null,
    chatTextOutline: false,
    chatBGOpacity: 0.2,
    filterChat: false,
    servSendR: false,
    useNetRerouting: false,
    showKillFeed: true,
    showMedals: true,
    scoreTextScale: 1,
    showWeaponSec: true,
    showWeaponMel: true,
    showPfp: true,
    oldBrowser: false,
    leaderType: 1,
    showDMGOverlay: true,
    showUnboxings: true,
    showPlayerMsg: true,
    canChangeLogo: true,
    canLoadMods: true,
    slidCont: 1,
    lagCompensation: 1,
    updateRate: 0,
    uiCustomScale: 1,
    uiScaling: true,
  };
  this.list = {
    defaultRegion: {
      name: "settings.local.region",
      cat: "local",
      get val() {
        return localStorage[w.PING_REGION_CACHE_KEY];
      },
      set val(F) {},
      html: function () {
        var F = {};
        for (var G of j.availableRegions) {
          F[G] = j.regionNames[G];
        }
        return x._html.settings.input.select(this, F);
      },
      set: function (F) {
        if (F && j.isProd) {
          localStorage.setItem(w.PING_REGION_CACHE_KEY, F);
        }
      },
    },
    lang: {
      name: "settings.local.lang",
      cat: "local",
      val: C.locale,
      html: function () {
        var F = {};
        for (var G of C.supported) {
          F[G] = j.langNames[G];
        }
        return x._html.settings.input.select(this, F);
      },
      set: function (F) {
        if (F) {
          C.setLocale(F);
          if (windowHolder.style.display == "block") {
            y.toggleWindow(false, q.gamepad.active);
          }
        }
      },
    },
    lagComp: {
      name: "settings.network.lagComp",
      cat: "network",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        E.tmp.lagCompensation = F;
      },
    },
    netRerouting: {
      name: "settings.network.netRerouting",
      cat: "network",
      val: false,
      needsRestart: true,
      info: "Requires Restart",
      type: "switch",
      set: function (F) {
        E.tmp.useNetRerouting = F;
      },
    },
    servSendR: {
      name: "settings.network.sendRate",
      cat: "network",
      val: false,
      needsRestart: true,
      info: "Requires Restart",
      type: "switch",
      set: function (F) {
        E.tmp.servSendR = F;
      },
    },
    aimFreezeFix: {
      name: "settings.experimental.aimFreezeFix",
      cat: "experimental",
      val: false,
      type: "switch",
      set: function (F) {
        E.tmp.aimFreezeFix = F;
      },
    },
    flickClamp: {
      name: "settings.experimental.mouseFlickFix",
      cat: "experimental",
      val: 200,
      min: 0,
      max: 500,
      step: 10,
      style: "width: 244px;",
      html: function () {
        return (
          x._html.settings.input.switch(E.list.mouseFlick) +
          x._html.settings.input.slider(this)
        );
      },
      set: function (F) {
        E.tmp.flickClamp = parseInt(F);
        q.flickClamp = parseInt(F);
      },
    },
    mouseFlick: {
      name: "settings.experimental.mouseFlickFix",
      info: "Prevents mouse from flicking too far",
      cat: "experimental",
      val: false,
      hide: true,
      html: function () {},
      set: function (F) {
        E.tmp.mouseFlick = !!F;
        q.mouseSkipFix = !!F;
      },
    },
    shaderRendering: {
      name: "settings.experimental.shaderRendering",
      cat: "experimental",
      val: false,
      needsRestart: true,
      info: "Requires Restart",
      type: "switch",
      set: function () {},
    },
    resolution: {
      name: "settings.quality.res",
      cat: "quality",
      pro: 1,
      perf: 0.4,
      val: 0.6,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.setResMlt(F);
      },
    },
    updateRate: {
      name: "settings.quality.updRate",
      cat: "quality",
      min: 0,
      max: 1200,
      val: 0,
      step: 10,
      type: "slider",
      set: function (F) {
        E.tmp.updateRate = F;
      },
    },
    aspectRatio: {
      name: "settings.quality.aspectRatio",
      cat: "quality",
      pro: "1280x1024",
      val: "",
      testfor: /^[-]?\d*x[-]?\d*$/g,
      placeholder: window.innerWidth + "x" + window.innerHeight,
      type: "input",
      html: function () {
        var F =
          "<select onchange='aspectSelect(\"aspectRatio\", this)' class='inputGrey2'>";
        F += "<option value='' disabled selected>Presets</option>";
        for (var G = 0; G < j.customRatios.length; G++) {
          F += "<option>" + j.customRatios[G] + "</option>";
        }
        return (F += "</select>") + x._html.settings.input.generic(this);
      },
      set: function (F) {
        k.aspectRatio = F;
        k.resize();
      },
    },
    antiAlias: {
      name: "settings.quality.antiAlias",
      cat: "quality",
      pro: false,
      perf: false,
      val: false,
      toggle: true,
      needsRestart: true,
      type: "switch",
      set: function (F) {
        k.antiA = !!F;
      },
    },
    postProcessing: {
      name: "settings.quality.post",
      cat: "quality",
      val: true,
      type: "switch",
      set: function (F) {
        k.postprocessing.enabled = F;
      },
    },
    lowSpec: {
      name: "settings.quality.lowSpec",
      cat: "quality",
      perf: true,
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.lowSpec = F;
      },
    },
    noTex: {
      name: "settings.quality.noTex",
      cat: "quality",
      perf: true,
      val: false,
      toggle: true,
      needsRestart: true,
      info: "Requires Restart",
      type: "switch",
      set: function (F) {
        k.noTex = F;
      },
    },
    mapDet: {
      name: "settings.quality.mapDet",
      cat: "quality",
      needsRestart: true,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.mapDet = F;
      },
    },
    particles: {
      name: "settings.quality.part",
      cat: "quality",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        m.active = F;
      },
    },
    particlesDist: {
      name: "settings.quality.partdist",
      cat: "quality",
      val: 160,
      min: 10,
      max: 1000,
      step: 10,
      type: "slider",
      set: function (F) {
        m.partDst = F;
      },
    },
    renderDist: {
      name: "settings.quality.renderdist",
      cat: "quality",
      val: 100,
      min: 1,
      max: 100,
      step: 1,
      type: "slider",
      set: function (F) {
        k.camera.far = F * 60;
      },
    },
    shadows: {
      name: "settings.quality.shadows",
      cat: "quality",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.toggleShadowMap(F);
      },
    },
    softShad: {
      name: "settings.quality.softShad",
      cat: "quality",
      needsRestart: true,
      pro: false,
      perf: false,
      val: false,
      type: "switch",
      set: function (F) {
        k.toggleShadQual(!!F);
      },
    },
    highResShad: {
      name: "settings.quality.highResShad",
      cat: "quality",
      needsRestart: true,
      pro: false,
      perf: false,
      val: false,
      type: "switch",
      set: function (F) {
        k.highResShad = !!F;
      },
    },
    shadowsDynamic: {
      name: "settings.quality.shadowsDynamic",
      cat: "quality",
      pro: false,
      perf: false,
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.toggleShadowAuto(F);
      },
    },
    ambientShading: {
      name: "settings.quality.ambient",
      cat: "quality",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.toggleMeshGroup("ambient_1", F);
        k.toggleMeshGroup("ambient_0", F);
      },
    },
    showTrails: {
      name: "settings.quality.trails",
      cat: "quality",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        m.showTrails = F;
      },
    },
    yourTrails: {
      name: "settings.quality.yourTrails",
      cat: "quality",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        m.yourTrails = F;
      },
    },
    muzzleFlash: {
      name: "settings.quality.mflash",
      cat: "quality",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        m.showMuzzle = F;
      },
    },
    sniperFlap: {
      name: "settings.quality.flap",
      cat: "quality",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.sniperFlap = F;
      },
    },
    textureAnim: {
      name: "settings.quality.textureAnim",
      cat: "quality",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.textureAnim = F;
        if (!F) {
          for (var G = 0; G < k.movTextures.length; ++G) {
            if ((D = k.movTextures[G]).tex.offset) {
              D.tex.offset[D.movD == 0 ? "x" : "y"] = 0;
            }
          }
          for (G = 0; G < k.pulsMats.length; ++G) {
            k.pulsMats[G].mat.emissiveIntensity = 0;
          }
          for (G = 0; G < k.frameMats.length; ++G) {
            (D = k.frameMats[G]).dur = D.orgDur;
            D.cur = 0;
            if (D.mat.map) {
              D.mat.map.offset.x = (D.cur % D.num) / D.num;
            }
          }
        }
      },
    },
    objectAnim: {
      name: "settings.quality.objectAnim",
      cat: "quality",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.objectAnim = F;
      },
    },
    screenShake: {
      name: "settings.quality.screenShake",
      cat: "quality",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.screenShake = F;
        k.shakeY = 0;
        k.shakeX = 0;
      },
    },
    weaponShine: {
      name: "settings.quality.weaponShine",
      cat: "quality",
      perf: false,
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.weaponShine = F;
      },
    },
    lighting: {
      name: "settings.quality.lighting",
      cat: "quality",
      perf: 0,
      val: 1,
      needsRestart: true,
      info: "Requires Restart",
      html: function () {
        return x._html.settings.input.select(this, {
          0: "Low",
          1: "Normal",
          2: "High",
        });
      },
      set: function (F) {
        k.lighting = F;
      },
    },
    scaleUI: {
      name: "settings.interface.scale",
      cat: "interface",
      perf: 1,
      val: 0.8,
      min: 0.1,
      max: 1,
      step: 0.1,
      style: "width: 180px;",
      html: function () {
        return (
          x._html.settings.input.switch(E.list.uiScaling) +
          x._html.settings.input.slider(this)
        );
      },
      set: function (F) {
        E.tmp.uiCustomScale = 1 - F + 1;
        window.scaleBase();
      },
    },
    uiScaling: {
      name: "settings.interface.scale",
      cat: "interface",
      val: true,
      hide: true,
      html: function () {},
      set: function (F) {
        E.tmp.uiScaling = F;
        window.scaleBase();
      },
    },
    showUI: {
      name: "settings.interface.ui",
      cat: "interface",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        y.hideGameUI = !F;
        if (F && E.tmp.chatDisplay == null) {
          E.tmp.chatDisplay = true;
        } else {
          chatUI.style.display = F ? "block" : "none";
        }
        window.refreshChat();
      },
    },
    oldScoreboard: {
      name: "settings.interface.scoreboard",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        leaderDisplay.style.display = F ? "block" : "none";
        killFeed.style.display =
          !F && E.list.showKills.val ? "inline-block" : "none";
        window.switchLeaderboard(F ? 0 : 1);
      },
    },
    oldBrowser: {
      name: "settings.interface.oldBrowser",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.oldBrowser = F;
      },
    },
    disableRarityAnim: {
      name: "settings.interface.rarityanim",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.rarityAnim = !F;
        refreshClassDisplay();
      },
    },
    showPfp: {
      name: "settings.interface.showPfp",
      cat: "interface",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showPfp = F;
      },
    },
    dynamicHP: {
      name: "settings.interface.hp",
      cat: "interface",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.dynamicHP = F;
      },
    },
    showHitInd: {
      name: "settings.interface.hitInd",
      cat: "interface",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.showHits = F;
        if (!F && z.hits) {
          z.hits.length = 0;
        }
      },
    },
    hitColor: {
      name: "settings.interface.hitColor",
      cat: "interface",
      val: "#FF3F3F",
      color: true,
      type: "color",
      set: function (F) {
        z.hitColor = g.hexToRGB(F).join(",");
      },
    },
    showDMG: {
      name: "settings.interface.dmg",
      cat: "interface",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.showDMG = F;
      },
    },
    dmgColor: {
      name: "settings.interface.dmgCol",
      cat: "interface",
      val: A.damage,
      color: true,
      type: "switch",
      set: function (F) {
        z.dmgColor = F;
      },
    },
    critColor: {
      name: "settings.interface.critCol",
      cat: "interface",
      val: A.critical,
      color: true,
      type: "color",
      set: function (F) {
        z.critColor = F;
      },
    },
    dmgScale: {
      name: "settings.interface.dmgScale",
      cat: "interface",
      pro: 0.5,
      val: 1,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.dmgScale = F * 30;
      },
    },
    showKills: {
      name: "settings.interface.killf",
      cat: "interface",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        killFeed.style.display = F ? "inline-block" : "none";
        E.tmp.showKillFeed = F;
      },
    },
    showKillC: {
      name: "settings.interface.kills",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        killCount.style.display = F ? "inline-block" : "none";
      },
    },
    showDeaths: {
      name: "settings.interface.deaths",
      cat: "interface",
      pro: true,
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        deathCount.style.display = F ? "inline-block" : "none";
      },
    },
    showScore: {
      name: "settings.interface.score",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        scoreCount.style.display = F ? "inline-block" : "none";
      },
    },
    showStreak: {
      name: "settings.interface.streak",
      cat: "interface",
      pro: true,
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        streakCount.style.display = F ? "inline-block" : "none";
      },
    },
    showPing: {
      name: "settings.interface.ping",
      cat: "interface",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        pingDisplay.style.display = F ? "block" : "none";
      },
    },
    showNetStat: {
      name: "settings.interface.net-stats",
      cat: "interface",
      val: false,
      hide: true,
      type: "switch",
      set: function (F) {
        B.trackPacketStats = F;
        B.resetPacketTally();
        window.updatePacketLoop(F);
        ingressDisplay.style.display = egressDisplay.style.display = F
          ? "block"
          : "none";
      },
    },
    showFPS: {
      name: "settings.interface.fps",
      cat: "interface",
      pro: true,
      perf: false,
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        fpsDisplay.style.display = menuFPSDisplay.style.display = F
          ? "block"
          : "none";
      },
    },
    showSpeed: {
      name: "settings.interface.speed",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.speedDisplay.display = F;
      },
    },
    speedOffX: {
      name: "settings.interface.speedOffX",
      cat: "interface",
      val: 5,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.speedDisplay.left = F * 10;
      },
    },
    speedOffY: {
      name: "settings.interface.speedOffY",
      cat: "interface",
      val: 5.4,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.speedDisplay.top = F * 10;
      },
    },
    speedScale: {
      name: "settings.interface.speedScale",
      cat: "interface",
      val: 2.4,
      min: 0.5,
      max: 5,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.speedDisplay.fontSize = F * 10;
      },
    },
    speedOpacity: {
      name: "settings.interface.speedOpacity",
      cat: "interface",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.speedDisplay.opacity = F;
      },
    },
    speedColor: {
      name: "settings.interface.speedColor",
      cat: "interface",
      val: "#ffea78",
      color: true,
      type: "color",
      set: function (F) {
        z.speedDisplay.color = F;
      },
    },
    speedColorMax: {
      name: "settings.interface.speedColorMax",
      cat: "interface",
      val: "#ff0000",
      color: true,
      type: "color",
      set: function (F) {
        z.speedDisplay.colorMax = F;
      },
    },
    showMedals: {
      name: "settings.interface.medals",
      cat: "interface",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showMedals = F;
      },
    },
    hideNames: {
      name: "settings.interface.hideNames",
      cat: "interface",
      val: 0,
      html: function () {
        return x._html.settings.input.select(this, {
          0: C.t("settings.interface.hideNames.all"),
          1: C.t("settings.interface.hideNames.team"),
          2: C.t("settings.interface.hideNames.enemy"),
          3: C.t("generic.off"),
        });
      },
      set: function () {},
    },
    nametagOpac: {
      name: "settings.interface.nametagOpac",
      cat: "interface",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.nametagOpacity = F;
      },
    },
    nametagStyle: {
      name: "settings.interface.nametagStyle",
      cat: "interface",
      val: 0,
      html: function () {
        return x._html.settings.input.select(this, {
          0: C.t("settings.interface.nametagStyle.all"),
          1: C.t("settings.interface.nametagStyle.name"),
          2: C.t("settings.interface.nametagStyle.nameLvl"),
          3: C.t("settings.interface.nametagStyle.health"),
        });
      },
      set: function (F) {
        z.nametagStyle = F;
      },
    },
    healthNum: {
      name: "settings.interface.healthNum",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.healthNum = F;
      },
    },
    healthColT: {
      name: "settings.interface.healthColT",
      cat: "interface",
      val: A.teams[0],
      color: true,
      type: "color",
      set: function (F) {
        z.healthColT = F;
      },
    },
    healthColE: {
      name: "settings.interface.healthColE",
      cat: "interface",
      val: A.teams[1],
      color: true,
      type: "color",
      set: function (F) {
        z.healthColE = F;
      },
    },
    xpBarCol: {
      name: "settings.interface.xpBarCol",
      cat: "interface",
      val: A.premium,
      color: true,
      type: "color",
      set: function (F) {
        igXPBarProg.style.backgroundColor = F;
      },
    },
    xpBarOpac: {
      name: "settings.interface.xpBarOpac",
      cat: "interface",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        igXPBar.style.opacity = F;
      },
    },
    shwChat: {
      name: "settings.chat.chat",
      cat: "chat",
      val: 0,
      html: function () {
        return x._html.settings.input.select(this, {
          0: C.t("settings.chat.chat.all"),
          1: C.t("settings.chat.chat.focus"),
          2: C.t("generic.off"),
        });
      },
      set: function (F) {
        chatList.style.display = F == 0 ? "block" : "none";
      },
    },
    chatFilter: {
      name: "settings.chat.chatFilter",
      cat: "chat",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.filterChat = F;
      },
    },
    showMessages: {
      name: "settings.chat.messages",
      cat: "chat",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showPlayerMsg = F;
      },
    },
    showUnboxings: {
      name: "settings.chat.unboxings",
      cat: "chat",
      pro: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showUnboxings = F;
      },
    },
    chatOp: {
      name: "settings.chat.chatOp",
      cat: "chat",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        chatList.style.opacity = F;
      },
    },
    chatBGOp: {
      name: "settings.chat.chatBGOp",
      cat: "chat",
      val: 0.2,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        E.tmp.chatBGOpacity = F;
        Array.from(document.getElementsByClassName("chatItem")).forEach(
          function (G) {
            G.style.backgroundColor = "rgba(0, 0, 0, " + F + ")";
          },
        );
      },
    },
    chatTextOutline: {
      name: "settings.chat.chatTextOutline",
      cat: "chat",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.chatTextOutline = F;
        Array.from(document.getElementsByClassName("chatItem")).forEach(
          function (G) {
            G.classList.toggle("chatTextOutline", F);
          },
        );
      },
    },
    chatHeight: {
      name: "settings.chat.chatHeight",
      cat: "chat",
      val: 2.5,
      min: 0,
      max: 5,
      step: 0.1,
      type: "slider",
      set: function (F) {
        chatList.style.maxHeight = F * 100 + "px";
        window.refreshChat();
      },
    },
    chatTimer: {
      name: "settings.chat.chatTimer",
      cat: "chat",
      val: 0,
      min: 0,
      max: 10,
      step: 0.5,
      type: "slider",
      set: function (F) {
        window.updateChatTimer(F);
      },
    },
    crosshairSho: {
      name: "settings.crosshair.type",
      cat: "crosshair",
      pro: 4,
      val: 1,
      html: function () {
        return x._html.settings.input.select(this, {
          0: C.t("generic.off"),
          1: C.t("generic.default"),
          2: C.t("settings.crosshair.type.2"),
          3: C.t("settings.crosshair.type.3"),
          4: C.t("settings.crosshair.type.4"),
          5: C.t("settings.crosshair.type.5"),
        });
      },
      set: function (F) {
        z.crosshairType = F;
        let G;
        let H = [
          "crosshairAlways",
          "crosshairOpacity",
          "crosshairLen",
          "crosshairThick",
        ];
        for (let I of H) {
          E.list[I].hide =
            I == "crosshairAlways" || I == "crosshairOpacity"
              ? F < 2
              : F == 4 || F < 2;
          G = document.getElementById(I + "_div");
          if (G) {
            G.style.display = E.list[I].hide ? "none" : "block";
          }
        }
        for (let J of [
          "crosshairColor",
          "crosshairShadow",
          "crosshairShadowThickess",
        ]) {
          E.list[J].hide = F < 1 || F == 4;
          G = document.getElementById(J + "_div");
          if (G) {
            G.style.display = E.list[J].hide ? "none" : "block";
          }
        }
        E.list.crosshairImage.hide = F != 4;
        G = document.getElementById("crosshairImage_div");
        if (G) {
          G.style.display = E.list.crosshairImage.hide ? "none" : "block";
        }
        E.list.crosshairGap.hide = F != 5;
        G = document.getElementById("crosshairGap_div");
        if (G) {
          G.style.display = E.list.crosshairGap.hide ? "none" : "block";
        }
        E.list.crosshairDot.hide = F != 5;
        G = document.getElementById("crosshairDot_div");
        if (G) {
          G.style.display = E.list.crosshairDot.hide ? "none" : "block";
        }
        E.list.crosshairStyle.hide = F > 3 || F < 2;
        G = document.getElementById("crosshairStyle_div");
        if (G) {
          G.style.display = E.list.crosshairStyle.hide ? "none" : "block";
        }
      },
    },
    crosshairStyle: {
      name: "settings.crosshair.style",
      cat: "crosshair",
      val: 0,
      hide: true,
      html: function () {
        return x._html.settings.input.select(this, {
          0: C.t("settings.crosshair.style.0"),
          1: C.t("settings.crosshair.style.1"),
          2: C.t("settings.crosshair.style.2"),
          3: C.t("settings.crosshair.style.3"),
          4: C.t("settings.crosshair.style.4"),
        });
      },
      set: function (F) {
        z.crosshairStyle = F;
      },
    },
    crosshairImage: {
      name: "settings.crosshair.image",
      cat: "crosshair",
      pro: g.assetsUrl("pro_crosshair.png"),
      val: "",
      hide: true,
      img: true,
      placeholder: C.t("settings.crosshair.image.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        if (z.crosshairImage.src != F && F.length) {
          z.crosshairImage.src = F;
        }
      },
    },
    crosshairOpacity: {
      name: "settings.crosshair.opacity.custom",
      cat: "crosshair",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      hide: true,
      type: "width: 180px;",
      html: function () {
        return (
          x._html.settings.input.switch(E.list.crosshairUseOpacity) +
          x._html.settings.input.slider(this)
        );
      },
      set: function (F) {
        z.crosshairOpacityCustom = F;
      },
    },
    crosshairUseOpacity: {
      name: "settings.crosshair.opacity.use",
      cat: "crosshair",
      val: false,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (F) {
        z.crosshairUseOpacityCustom = F;
      },
    },
    crosshairAlways: {
      name: "settings.crosshair.always",
      cat: "crosshair",
      pro: true,
      val: false,
      hide: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.crosshairAlways = F;
      },
    },
    crosshairColor: {
      name: "settings.crosshair.color",
      cat: "crosshair",
      val: A.crosshair.background,
      color: true,
      type: "color",
      set: function (F) {
        z.crosshairColor = F;
      },
    },
    crosshairShadow: {
      name: "settings.crosshair.shadow.color",
      cat: "crosshair",
      val: A.crosshair.shadow,
      color: true,
      type: "color",
      set: function (F) {
        z.crosshairShadow = F;
      },
    },
    crosshairShadowThickess: {
      name: "settings.crosshair.shadow.thickness",
      cat: "crosshair",
      val: 1,
      min: 0,
      max: 3,
      step: 1,
      hide: true,
      type: "slider",
      set: function (F) {
        z.crosshairShadowThickness = F;
      },
    },
    crosshairThick: {
      name: "settings.crosshair.thickness",
      cat: "crosshair",
      val: 2,
      min: 0,
      max: 100,
      step: 0.5,
      hide: true,
      type: "slider",
      set: function (F) {
        z.crosshairThick = F;
      },
    },
    crosshairLen: {
      name: "settings.crosshair.size",
      cat: "crosshair",
      val: 16,
      min: 0,
      max: 100,
      step: 0.5,
      hide: true,
      type: "slider",
      set: function (F) {
        z.crosshairLen = F;
      },
    },
    crosshairGap: {
      name: "settings.crosshair.gap",
      cat: "crosshair",
      val: 0,
      min: -100,
      max: 100,
      step: 1,
      hide: true,
      type: "slider",
      set: function (F) {
        z.crosshairGap = F;
      },
    },
    crosshairDot: {
      name: "settings.crosshair.dot",
      cat: "crosshair",
      val: false,
      hide: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.crosshairDot = F;
      },
    },
    hitm: {
      name: "settings.hitmarker.hitm",
      cat: "hitmarker",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.hitSet.enabled = F;
      },
    },
    hitmCol: {
      name: "settings.hitmarker.color",
      cat: "hitmarker",
      val: "#FFFFFF",
      color: true,
      type: "color",
      set: function (F) {
        z.hitSet.colors = [
          [F, F],
          [F, F],
        ];
      },
    },
    hitmKCol: {
      name: "settings.hitmarker.kcolor",
      cat: "hitmarker",
      val: "#FF0000",
      color: true,
      type: "color",
      set: function (F) {
        z.hitSet.kColors = [
          [F, F],
          [F, F],
        ];
      },
    },
    hitOpac: {
      name: "settings.hitmarker.opacity",
      cat: "hitmarker",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.hitSet.opacity = F;
      },
    },
    hitmLen: {
      name: "settings.hitmarker.leng",
      cat: "hitmarker",
      val: 25,
      min: 1,
      max: 50,
      step: 1,
      type: "slider",
      set: function (F) {
        z.hitSet.length = F;
      },
    },
    hitmThick: {
      name: "settings.hitmarker.thickness",
      cat: "hitmarker",
      val: 7,
      min: 1,
      max: 20,
      step: 1,
      type: "slider",
      set: function (F) {
        z.hitSet.thickness = F;
      },
    },
    hitmSpac: {
      name: "settings.hitmarker.spacing",
      cat: "hitmarker",
      val: 37,
      min: 5,
      max: 60,
      step: 1,
      type: "slider",
      set: function (F) {
        z.hitSet.spacing = F;
      },
    },
    hitmAnimD: {
      name: "settings.hitmarker.animD",
      cat: "hitmarker",
      val: 0.14,
      min: 0.1,
      max: 0.5,
      step: 0.01,
      type: "slider",
      set: function (F) {
        z.hitSet.inc = F;
      },
    },
    hitmAnimS: {
      name: "settings.hitmarker.animS",
      cat: "hitmarker",
      val: 0.008,
      min: 0.001,
      max: 0.01,
      step: 0.001,
      type: "slider",
      set: function (F) {
        z.hitSet.speed = F;
      },
    },
    hitmFad: {
      name: "settings.hitmarker.hitmFad",
      cat: "hitmarker",
      val: 0.0062,
      min: 0.0001,
      max: 0.01,
      step: 0.0001,
      set: function (F) {
        z.hitSet.fadeOut = F;
      },
    },
    customHitmarker: {
      name: "settings.hitmarker.custom",
      cat: "hitmarker",
      val: "",
      img: true,
      placeholder: C.t("settings.hitmarker.custom.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        if (/\.(jpg|jpeg|png)/.test(F)) {
          z.hitmarker.loaded = false;
          if (!z.hitmarker.image) {
            z.hitmarker.image = new Image();
            z.hitmarker.image.onload = () => (z.hitmarker.loaded = true);
          }
          z.hitmarker.image.src = F;
          z.hitmarker.custom = false;
        } else if (F.length) {
          z.hitmarker.image = false;
          hitmarker.src = F;
          z.hitmarker.custom = true;
        } else {
          z.hitmarker.image = false;
          z.hitmarker.custom = false;
        }
      },
    },
    sensitivityX: {
      name: "settings.gameplay.sensitivityX",
      cat: "gameplay",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.kbmInput.sensX = F;
      },
    },
    sensitivityY: {
      name: "settings.gameplay.sensitivityY",
      cat: "gameplay",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.kbmInput.sensY = F;
      },
    },
    aimSensitivityX: {
      name: "settings.gameplay.aimsensX",
      cat: "gameplay",
      pro: 0.69,
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.kbmInput.aimX = F;
      },
    },
    aimSensitivityY: {
      name: "settings.gameplay.aimsensY",
      cat: "gameplay",
      pro: 0.69,
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.kbmInput.aimY = F;
      },
    },
    slidCont: {
      name: "settings.gameplay.slidCont",
      cat: "gameplay",
      val: true,
      toggle: true,
      info: "Requires respawn",
      type: "switch",
      set: function (F) {
        E.tmp.slidCont = F ? 1 : 0;
      },
    },
    scrollDir: {
      name: "settings.gameplay.scrollDir",
      cat: "gameplay",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.scrollDirM = F ? 1 : -1;
      },
    },
    challMode: {
      name: "settings.gameplay.challenge",
      cat: "gameplay",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        window.toggleChal(F);
      },
    },
    invertY: {
      name: "settings.gameplay.invert",
      cat: "gameplay",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        q.kbmInput.invert = F;
      },
    },
    sensitivityXCntrl: {
      name: "settings.controller.sensitivityX",
      cat: "controller",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.cntrlInput.sensX = F * 5;
      },
    },
    sensitivityYCntrl: {
      name: "settings.controller.sensitivityY",
      cat: "controller",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.cntrlInput.sensY = F * 5;
      },
    },
    aimSensitivityXCntrl: {
      name: "settings.controller.aimsensX",
      cat: "controller",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.cntrlInput.aimX = F * 5;
      },
    },
    aimSensitivityYCntrl: {
      name: "settings.controller.aimsensY",
      cat: "controller",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (F) {
        q.cntrlInput.aimY = F * 5;
      },
    },
    deadZoneL: {
      name: "settings.controller.deadZoneL",
      cat: "controller",
      val: 0.3,
      min: 0,
      max: 1,
      step: 0.05,
      type: "slider",
      set: function (F) {
        q.cntrlInput.deadZoneL = F;
      },
    },
    deadZoneR: {
      name: "settings.controller.deadZoneR",
      cat: "controller",
      val: 0.25,
      min: 0,
      max: 1,
      step: 0.05,
      type: "slider",
      set: function (F) {
        q.cntrlInput.deadZoneR = F;
      },
    },
    triggerThres: {
      name: "settings.controller.triggerThres",
      cat: "controller",
      val: 0.1,
      min: 0,
      max: 1,
      step: 0.05,
      type: "slider",
      set: function (F) {
        q.cntrlInput.triggerThres = F;
      },
    },
    invertYCntrl: {
      name: "settings.controller.invert",
      cat: "controller",
      val: false,
      type: "switch",
      set: function (F) {
        q.cntrlInput.invert = F;
      },
    },
    vibration: {
      name: "settings.controller.vibration",
      cat: "controller",
      val: true,
      type: "switch",
      set: function (F) {
        q.cntrlInput.vibration = F;
      },
    },
    gradSpeed: {
      name: "settings.controller.gradSpeed",
      cat: "controller",
      val: false,
      type: "switch",
      set: function (F) {
        q.cntrlInput.gradSpeed = F;
        q.speedLmt = 1;
      },
    },
    sensitivityXMbl: {
      name: "settings.mobile.sensitivityX",
      cat: "mobile",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !q.isMobile,
      type: "slider",
      set: function (F) {
        q.mblInput.sensX = F * 4;
      },
    },
    sensitivityYMbl: {
      name: "settings.mobile.sensitivityY",
      cat: "mobile",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !q.isMobile,
      type: "slider",
      set: function (F) {
        q.mblInput.sensY = F * 4;
      },
    },
    aimSensitivityXMbl: {
      name: "settings.mobile.aimsensX",
      cat: "mobile",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !q.isMobile,
      type: "slider",
      set: function (F) {
        q.mblInput.aimX = F * 4;
      },
    },
    aimSensitivityYMbl: {
      name: "settings.mobile.aimsensY",
      cat: "mobile",
      val: 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !q.isMobile,
      type: "slider",
      set: function (F) {
        q.mblInput.aimY = F * 4;
      },
    },
    invertYMbl: {
      name: "settings.mobile.invert",
      cat: "mobile",
      val: false,
      hide: !q.isMobile,
      type: "slider",
      set: function (F) {
        q.mblInput.invert = F;
      },
    },
    vibrationMbl: {
      name: "settings.mobile.vibration",
      cat: "mobile",
      val: true,
      hide: !q.isMobile,
      type: "switch",
      set: function (F) {
        q.mblInput.vibration = F;
      },
    },
    gradSpeedMbl: {
      name: "settings.mobile.gradSpeed",
      cat: "mobile",
      val: true,
      hide: !q.isMobile,
      type: "switch",
      set: function (F) {
        q.mblInput.gradSpeed = F;
        q.speedLmt = 1;
      },
    },
    sound: {
      name: "settings.audio.sound",
      cat: "audio",
      pro: 0.1,
      perf: 0.1,
      val: 0.8,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        SOUND.setVolume(F, 0);
      },
    },
    ambientVolume: {
      name: "settings.audio.ambient",
      cat: "audio",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        SOUND.setVolume(F, 2);
      },
    },
    audioInput: {
      name: "settings.audio.input",
      info: "Select hardware device for audio/microphone",
      cat: "audio",
      val: "default",
      options: {
        default: "Default",
      },
      type: "select",
      html: function () {
        return x._html.settings.input.select(this, this.options);
      },
      set: function (F) {
        E.tmp[this.key] = F;
        if (window.updateAudioInputs) {
          window.updateAudioInputs();
        }
      },
    },
    voiceVolume: {
      name: "settings.audio.voice",
      cat: "audio",
      pro: 0,
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        SOUND.setVolume(F, 1);
      },
    },
    gunsVolume: {
      name: "settings.audio.weps",
      cat: "audio",
      val: 0.5,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        SOUND.setVolume(F, 3);
      },
    },
    playerVolume: {
      name: "settings.audio.player",
      cat: "audio",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        SOUND.setVolume(F, 4);
      },
    },
    uiVolume: {
      name: "settings.audio.ui",
      cat: "audio",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        SOUND.setVolume(F, 5);
      },
    },
    assetVolume: {
      name: "settings.audio.asset",
      cat: "audio",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        SOUND.setVolume(F, 6);
      },
    },
    streamMode: {
      name: "settings.gameprivacy.streamer",
      cat: "gameprivacy",
      val: false,
      dontInit: true,
      toggle: true,
      type: "switch",
      set: function (hideNames) {
        z.hideNames = hideNames;
        window.toggleStrm(hideNames);
      },
    },
    anonMode: {
      name: "settings.gameprivacy.anon",
      cat: "gameprivacy",
      val: false,
      toggle: true,
      verified: true,
      info: "Requires Verification",
      type: "switch",
      set: function (F) {
        E.tmp.anonMode = F;
      },
    },
    fov: {
      name: "settings.viewmodel.fov",
      cat: "viewmodel",
      pro: 110,
      val: j.fov + 10,
      min: 60,
      max: 150,
      step: 5,
      type: "slider",
      set: function (F) {
        k.setFov(F);
      },
    },
    fpsFOV: {
      name: "settings.viewmodel.fps",
      cat: "viewmodel",
      pro: 105,
      val: j.fov + 10,
      min: 60,
      max: 150,
      step: 5,
      type: "slider",
      set: function (F) {
        k.setFPSFov(F);
      },
    },
    weaponBob: {
      name: "settings.viewmodel.bobbing",
      cat: "viewmodel",
      pro: 0.2,
      perf: 0,
      val: 0.9,
      min: 0,
      max: 3,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.weaponBob = F;
      },
    },
    weaponLean: {
      name: "settings.viewmodel.leaning",
      cat: "viewmodel",
      pro: 2,
      perf: 0,
      val: 1,
      min: 0,
      max: 6,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.weaponLean = F;
      },
    },
    weaponRot: {
      name: "settings.viewmodel.rot",
      cat: "viewmodel",
      pro: 0,
      val: 0,
      min: -1,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.weaponRot = F;
      },
    },
    weaponOffX: {
      name: "settings.viewmodel.xOff",
      cat: "viewmodel",
      pro: 1.4,
      val: 1,
      min: 0,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.weaponOffX = F;
      },
    },
    weaponOffY: {
      name: "settings.viewmodel.yOff",
      cat: "viewmodel",
      pro: 2,
      val: 1,
      min: 0,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.weaponOffY = F;
      },
    },
    weaponOffZ: {
      name: "settings.viewmodel.zOff",
      cat: "viewmodel",
      pro: 1.5,
      val: 1,
      min: 0,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.weaponOffZ = F;
      },
    },
    weaponADSOffY: {
      name: "settings.viewmodel.yOffADS",
      cat: "viewmodel",
      val: 1,
      min: 0,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.weaponADSOffY = F;
      },
    },
    leftHand: {
      name: "settings.viewmodel.leftHand",
      cat: "viewmodel",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.leftHand = F;
      },
    },
    adsFovMlt: {
      name: "settings.viewmodel.adsFovMlt",
      cat: "viewmodel",
      val: 1,
      min: 0.2,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.adsFovMlt = F;
      },
    },
    aimAnim: {
      name: "settings.viewmodel.aimAnim",
      cat: "viewmodel",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.aimAnim = F;
      },
    },
    hideADS: {
      name: "settings.viewmodel.show.ads",
      cat: "viewmodel",
      pro: true,
      perf: true,
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.hideADS = F;
      },
    },
    showHands: {
      name: "settings.viewmodel.show.hands",
      cat: "viewmodel",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        k.showHands = F;
        window.updateWeaponShow(0, F);
      },
    },
    showWeapon: {
      name: "settings.viewmodel.show.primary",
      cat: "viewmodel",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showWeapon = F;
        v.hideWeapon[0] = !F;
        window.updateWeaponShow(1, F);
      },
    },
    showWeaponSec: {
      name: "settings.viewmodel.show.secondary",
      cat: "viewmodel",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showWeaponSec = F;
        v.hideWeapon[1] = !F;
        window.updateWeaponShow(2, F);
      },
    },
    showWeaponMel: {
      name: "settings.viewmodel.show.melee",
      cat: "viewmodel",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showWeaponMel = F;
        v.hideWeapon[2] = !F;
        window.updateWeaponShow(3, F);
      },
    },
    roundArms: {
      name: "settings.viewmodel.roundArms",
      cat: "viewmodel",
      val: false,
      toggle: true,
      type: "switch",
      needsRestart: true,
      info: "Requires Restart",
      set: function (F) {
        k.roundArms = !!F;
      },
    },
    hudHealthHigh: {
      name: "settings.editing.health.high",
      cat: "editing",
      val: A.hudHealth.high,
      color: true,
      type: "switch",
      set: function () {},
    },
    hudHealthLow: {
      name: "settings.editing.health.low",
      cat: "editing",
      val: A.hudHealth.low,
      color: true,
      type: "color",
      set: function () {},
    },
    showSpdLines: {
      name: "settings.editing.speedLines",
      cat: "editing",
      perf: 0,
      val: 0.6,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.shoSpdLines = F;
      },
    },
    spdLinesCol: {
      name: "settings.editing.spdLinesCol",
      cat: "editing",
      val: "#e6e6e6",
      color: true,
      type: "color",
      set: function (F) {
        z.spdLinesCol = g.hexToRGB(F).join(",");
      },
    },
    showPScore: {
      name: "settings.editing.score.show",
      cat: "editing",
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.scoreText.disabled = !F;
      },
    },
    scoreColor: {
      name: "settings.editing.score.color",
      cat: "editing",
      val: A.popupScore,
      color: true,
      type: "color",
      set: function (F) {
        z.scoreText.color = F;
      },
    },
    scoreShadow: {
      name: "settings.editing.score.shadow",
      cat: "editing",
      val: false,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.scoreText.shadow = F ? 3 : 0;
      },
    },
    scoreScale: {
      name: "settings.editing.score.scale",
      cat: "editing",
      pro: 0.6,
      val: 1,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (F) {
        E.tmp.scoreTextScale = F || 1;
      },
    },
    scoreOffX: {
      name: "settings.editing.scoreOffX",
      cat: "editing",
      val: 5,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.scoreText.left = F * 10;
      },
    },
    scoreOffY: {
      name: "settings.editing.scoreOffY",
      cat: "editing",
      pro: 2.5,
      val: 3.7,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (F) {
        z.scoreText.top = F * 10;
      },
    },
    saturationn: {
      name: "settings.editing.saturation",
      cat: "editing",
      val: 1,
      perf: 1,
      min: 0,
      max: 3,
      step: 0.1,
      type: "slider",
      set: function () {
        window.bundleFilters(0);
      },
    },
    menuSaturation: {
      name: "settings.editing.menuSaturation",
      cat: "editing",
      pro: 1,
      val: 1,
      min: 0,
      max: 3,
      step: 0.1,
      type: "slider",
      set: function () {
        window.bundleFilters(1);
      },
    },
    hue: {
      name: "settings.editing.hue",
      cat: "editing",
      val: 0,
      min: 0,
      max: 100,
      step: 5,
      type: "slider",
      set: function () {
        window.bundleFilters(0);
      },
    },
    menuHue: {
      name: "settings.editing.menuHue",
      cat: "editing",
      val: 0,
      min: 0,
      max: 100,
      step: 5,
      type: "slider",
      set: function () {
        window.bundleFilters(1);
      },
    },
    vignette: {
      name: "settings.editing.vignette",
      cat: "editing",
      val: 0,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (F) {
        if (F == 1) {
          vignette.style.removeProperty("opacity");
        } else {
          vignette.style.opacity = F;
        }
      },
    },
    feedLimit: {
      name: "settings.editing.feedLimit",
      cat: "editing",
      pro: 4,
      val: 8,
      min: 1,
      max: 10,
      step: 1,
      type: "slider",
      set: function (F) {
        window.refreshFeed(F);
      },
    },
    bulletTracerCol: {
      name: "settings.editing.tracercol",
      cat: "editing",
      val: "#ffffdb",
      color: true,
      html: function () {
        return (
          x._html.settings.input.switch(E.list.bulletTracers) +
          x._html.settings.input.color(this)
        );
      },
      set: function (F) {
        m.setTracerColor(F);
      },
    },
    bulletTracers: {
      name: "settings.editing.tracer",
      cat: "editing",
      perf: false,
      val: true,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (F) {
        m.showTracers = F;
      },
    },
    canLoadMods: {
      name: "settings.mods.load",
      cat: "mods",
      val: true,
      type: "switch",
      set: function (F) {
        E.tmp.canLoadMods = F;
      },
    },
    canChangeLogo: {
      name: "settings.mods.logo",
      cat: "mods",
      val: true,
      type: "switch",
      set: function (F) {
        E.tmp.canChangeLogo = F;
      },
    },
    autoLoadLast: {
      name: "settings.mods.auto",
      cat: "mods",
      val: false,
      type: "switch",
      set: function () {},
    },
    scopeBorders: {
      name: "settings.mods.borders",
      cat: "mods",
      pro: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        z.scopeBorders = F;
        Array.from(document.querySelectorAll(".black")).forEach(
          (G) => (G.style.display = F ? "block" : "none"),
        );
      },
    },
    customScope: {
      name: "settings.mods.scope",
      cat: "mods",
      pro: g.assetsUrl("pro_scope.png"),
      val: "",
      img: true,
      placeholder: C.t("settings.mods.scope.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        if (/\.(jpg|jpeg|png)/.test(F)) {
          k.aimRecticle.loaded = false;
          k.aimRecticle.image.src = F;
          k.aimRecticle.custom = false;
        } else {
          recticleImg.src =
            F.length > 1 ? F : g.assetsUrl("/textures/recticle.png");
          if (
            k.aimRecticle.image.src != g.assetsUrl("/textures/recticle.png")
          ) {
            k.aimRecticle.loaded = false;
            k.aimRecticle.image.src = g.assetsUrl("/textures/recticle.png");
          }
          k.aimRecticle.custom = F.length > 1;
        }
      },
    },
    customADSDot: {
      name: "settings.mods.dot",
      cat: "mods",
      pro: g.assetsUrl("pro_ads.png"),
      val: "",
      img: true,
      placeholder: C.t("settings.mods.dot.paste"),
      type: "url",
      set: function (F) {
        if (F) {
          window.updateAimDot(-2, F);
          window.saveVal("reticleIndex", -2);
        }
      },
    },
    reticleWidth: {
      name: "settings.mods.dot.width",
      cat: "mods",
      val: 2,
      min: 0.1,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.aimDot.width = F * 10;
        aimDot.style.width = F * 10 + "px";
      },
    },
    reticleHeight: {
      name: "settings.mods.dot.height",
      cat: "mods",
      val: 2,
      min: 0.1,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (F) {
        k.aimDot.height = F * 10;
        aimDot.style.height = F * 10 + "px";
      },
    },
    endMessage: {
      name: "settings.mods.endmessage",
      cat: "mods",
      val: "",
      str: true,
      placeholder: C.t("settings.mods.endmessage"),
      type: "text",
      set: function () {},
    },
    customAmmo: {
      name: "settings.mods.ammo",
      cat: "mods",
      val: "",
      img: true,
      placeholder: C.t("settings.mods.ammo.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        ammoIcon.src = F.length > 1 ? F : g.assetsUrl("/textures/ammo_0.png");
      },
    },
    customKills: {
      name: "settings.mods.kills",
      cat: "mods",
      val: "",
      img: true,
      placeholder: C.t("settings.mods.kills.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        killsIcon.src = F.length > 1 ? F : location.origin + "/img/skull_0.png";
      },
    },
    customDeaths: {
      name: "settings.mods.deaths",
      cat: "mods",
      val: "",
      img: true,
      placeholder: C.t("settings.mods.deaths.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        deathsIcon.src =
          F.length > 1 ? F : location.origin + "/img/skull_1.png";
      },
    },
    customStreak: {
      name: "settings.mods.streak",
      cat: "mods",
      val: "",
      img: true,
      placeholder: C.t("settings.mods.streak.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        streakIcon.src =
          F.length > 1 ? F : location.origin + "/img/skull_2.png";
      },
    },
    useDamageOverlay: {
      name: "settings.mods.usedamage",
      cat: "mods",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (F) {
        E.tmp.showDMGOverlay = F;
        if (!F) {
          z.bloodOpacity = 0;
          bloodDisplay.style.display = "none";
          bloodDisplay.style.opacity = 0;
        }
      },
    },
    customDamage: {
      name: "settings.mods.damage",
      cat: "mods",
      val: "",
      img: true,
      placeholder: C.t("settings.mods.damage.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        if (/\.(jpg|jpeg|png)/.test(F)) {
          z.bloodLoaded = false;
          z.bloodImage.src = F;
          z.bloodCustom = false;
        } else {
          bloodDisplay.src =
            F.length > 1 ? F : location.origin + "/img/blood.png";
          if (z.bloodImage.src != location.origin + "/img/blood.png") {
            z.bloodLoaded = false;
            z.bloodImage.src = location.origin + "/img/blood.png";
          }
          z.bloodCustom = F.length > 1;
        }
      },
    },
    customTimer: {
      name: "settings.mods.timer",
      cat: "mods",
      val: "",
      img: true,
      placeholder: C.t("settings.mods.timer.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        timerIcon.src = F.length > 1 ? F : location.origin + "/img/timer.png";
      },
    },
    customGameOverlay: {
      name: "settings.mods.overlay",
      cat: "mods",
      val: "",
      img: true,
      placeholder: C.t("settings.mods.overlay.paste"),
      type: "url",
      set: function (F) {
        F = g.isURL(F) && !/\.svg/.test(F) ? F : "";
        overlay.style.backgroundImage = F.length > 1 ? "url('" + F + "')" : "";
      },
    },
  };
  this.init = function () {
    for (var F in this.list) {
      this.list[F].key = F;
      this.list[F].def = this.list[F].val;
      if (this.list[F].set && !this.list[F].dontInit) {
        var G = getSavedVal("kro_setngss_" + F);
        this.list[F].val = G === null ? this.list[F].val : G;
        if (this.list[F].val == "false") {
          this.list[F].val = false;
        }
        if (this.list[F].val == "true") {
          this.list[F].val = true;
        }
        if (this.list[F].val == "undefined") {
          this.list[F].val = this.list[F].def;
        }
        this.list[F].val =
          this.list[F].val && this.list[F].val.replace
            ? this.list[F].val.replace(/[><]/g, "")
            : this.list[F].val;
        if (
          this.list[F].testfor &&
          !this.list[F].testfor.test(this.list[F].val)
        ) {
          this.list[F].val = this.list[F].def;
        }
        if (
          this.list[F].img &&
          !/\.(jpg|jpeg|png|gif|webp|ico)/.test(this.list[F].val)
        ) {
          this.list[F].val = this.list[F].def;
        }
        if (
          this.list[F].type &&
          this.list[F].color &&
          !g.isHexColor(this.list[F].val)
        ) {
          this.list[F].val = this.list[F].def;
        }
        if (
          (this.list[F].str || this.list[F].img) &&
          this.list[F].val &&
          this.list[F].val.replace
        ) {
          this.list[F].val = this.list[F].val
            .replace(/\u0027/g, "")
            .replace(/\u0022/g, "");
        }
        if (this.list[F].min || this.list[F].max) {
          this.list[F].val = Math.min(
            this.list[F].max,
            Math.max(this.list[F].min, +this.list[F].val),
          );
        }
        this.list[F].set(this.list[F].val, true);
      }
    }
  };
  this.set = function (F, G, H, I, J) {
    if (E.list[F]) {
      if (
        (G =
          (G = G === null ? E.list[F].val : G) && G.replace
            ? G.replace(/[><]/g, "")
            : G) == "false"
      ) {
        G = false;
      }
      if (G == "true") {
        G = true;
      }
      if (G == "undefined") {
        G = E.list[F].def;
      }
      if (I && E.list[F].testfor && !E.list[F].testfor.test(G)) {
        G = E.list[F].def;
      }
      if (E.list[F].img && !/\.(jpg|jpeg|png|gif|webp|ico)/.test(G)) {
        G = E.list[F].def;
      }
      if (E.list[F].type && E.list[F].color && !g.isHexColor(G)) {
        G = E.list[F].def;
      }
      if ((E.list[F].str || E.list[F].img) && G && G.replace) {
        G = G.replace(/\u0027/g, "").replace(/\u0022/g, "");
      }
      if (E.list[F].min || E.list[F].max) {
        G = Math.min(E.list[F].max, Math.max(E.list[F].min, +G));
      }
      if (document.getElementById("slid_" + F)) {
        document.getElementById("slid_" + F).value = G;
      }
      if (document.getElementById("slid_input_" + F)) {
        document.getElementById("slid_input_" + F).value = G;
      }
      if (!J) {
        E.list[F].val = G;
      }
      E.list[F].set(G);
      if (!J) {
        saveVal("kro_setngss_" + F, G);
      }
      if (!H) {
        selectSettingPre(2, true);
      }
    }
  };
  this.export = function (F) {
    var G = {};
    var H = q.export();
    for (var I in E.list) {
      if (E.list[I].val != E.list[I].def) {
        G[I] = E.list[I].val;
      }
    }
    if (Object.keys(H).length) {
      G.controls = H;
    }
    if (F) {
      return JSON.stringify(G);
    } else {
      downloadFile("settings.txt", G);
      return;
    }
  };
  this.import = function (F) {
    var G = F || prompt("Copy Paste Settings Text Here");
    if (G && G != "") {
      try {
        let L = JSON.parse(G);
        for (var H in E.list) {
          var I = L[H] == null ? E.list[H].def : L[H];
          setSetting(H, I, null, true);
        }
        if (L.controls) {
          for (var J in L.controls) {
            if (q.binds[J]) {
              for (var K = 0; K < L.controls[J].length; K++) {
                if (L.controls[J][K] == null) {
                  L.controls[J][K] = q.binds[J].def[K];
                }
                q.binds[J].val[K] = L.controls[J][K];
                saveVal(
                  "cont_" +
                    (K +
                      (J == "streakKeys"
                        ? 18
                        : J == "toggleKeys"
                          ? 27
                          : J == "premiumKeys"
                            ? 34
                            : 0)),
                  L.controls[J][K],
                );
              }
            }
          }
        }
        q.checkForScroll();
        if (!F) {
          showWindow(1);
        }
      } catch (M) {
        alert("Failed to import settings with error:\n" + M.toString());
      }
    }
  };
};
